<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>business</mat-icon> Organizations
    </h2>
  </div>
  <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-raised-button color="primary" title="Add Lab" (click)="editLab(0)" [disabled]="authService.isReadOnly()">
      <mat-icon>add</mat-icon> Add Organization
    </button>
    &nbsp;&nbsp;
    <a mat-raised-button href="https://lams.nelac-institute.org/Search" target="_blank" title="Find a lab in LAMS">
      Find a lab in LAMS <mat-icon>open_in_new</mat-icon>
    </a>
  </div>
</div>
<br />
<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{labs.length}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter Organizations" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-row>Results ({{labs.length}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      <ng-container matColumnDef="labName">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="37" fxFlex.lt-sm="100">Organization Name</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="37" fxFlex.lt-sm="100">
          <a (click)="editLab(result.id)" title="Edit {{result.labName}}"
            *ngIf="result.labName != ''">{{result.displayName}}</a>
          <a (click)="editLab(result.id)" title="Edit Lab" *ngIf="result.labName == ''">Lab</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="active">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxFlex.lt-sm="100">Active</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="10" fxFlex.lt-sm="100">
          <span *ngIf="result.active">Yes</span>
          <span *ngIf="!result.active">No</span>
        </mat-cell>
      </ng-container> 
      <ng-container matColumnDef="orelap">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxFlex.lt-sm="100">Orelap</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="10" fxFlex.lt-sm="100">{{result.orelap}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="labAddress1">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20" fxFlex.lt-sm="100">Address</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="20" fxFlex.lt-sm="100">
          <span>
            {{result.labAddress1}}
            <span *ngIf="result.labAddress2 != '' && result.labAddress2 != null"><br />{{result.labAddress2}}</span>
            <br />
            {{result.labCity}}<span *ngIf="result.labCity != '' && result.labCity != null">,</span>
            {{result.labState}} {{result.labZip}}
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="labEmail">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20" fxFlex.lt-sm="100">Email</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="20" fxFlex.lt-sm="100">
          <span>{{result.labEmail}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="labPhone">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxFlex.lt-sm="100">Phone</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="10" fxFlex.lt-sm="100">
          <span>{{result.labPhone}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef fxFlex="7" fxFlex.lt-sm="100" style="justify-content: center !important;">
          Actions</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="7" fxFlex.lt-sm="100" style="justify-content: center !important;">
          <a href="javascript:void(0)" (click)="deleteLab(result.id)" title="Delete {{result.labName}}" *ngIf="!authService.isReadOnly()">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, labs.length]" #TablePaginator="matPaginator"
      showFirstLastButtons></mat-paginator>
  </div>
</mat-card>